import type { InputHTMLAttributes, ReactNode, Ref } from "react";
import { classes } from "../../nucleo/classes";

export interface PropsDaOpcao
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "children"> {
  /** `radio` para escolha única, `checkbox` para escolha múltipla. */
  tipo: "radio" | "checkbox";
  titulo: ReactNode;
  descricao?: ReactNode;
  /** Selo curto à direita — no protótipo é a `.tag` de "sensível" ou "pré-preenchida". */
  etiqueta?: ReactNode;
  classeDaEtiqueta?: string;
  ref?: Ref<HTMLInputElement>;
}

/** Uma opção no visual `.opt` do protótipo: a linha inteira é clicável. */
export function Opcao({
  tipo,
  titulo,
  descricao,
  etiqueta,
  classeDaEtiqueta,
  className,
  ...resto
}: PropsDaOpcao) {
  return (
    <label className={classes("opcao", className)}>
      <input type={tipo} {...resto} />
      <span className="flex-1">
        <span className="opcao__titulo">{titulo}</span>
        {descricao ? <span className="opcao__descricao"> — {descricao}</span> : null}
      </span>
      {etiqueta ? (
        <span className={classes("etiqueta", classeDaEtiqueta)}>{etiqueta}</span>
      ) : null}
    </label>
  );
}

export interface PropsDoGrupoDeOpcoes {
  /** Enunciado do grupo. Vira o `aria-label` do conjunto de rádios. */
  rotulo: string;
  /** Some com o enunciado na tela sem tirá-lo do leitor de tela. */
  rotuloOculto?: boolean;
  children: ReactNode;
  className?: string;
}

export function GrupoDeOpcoes({
  rotulo,
  rotuloOculto = false,
  children,
  className,
}: PropsDoGrupoDeOpcoes) {
  return (
    <fieldset className={classes("border-0 p-0 m-0", className)}>
      <legend
        className={classes(
          "campo__rotulo",
          // `sr-only` do Tailwind: continua no acessível, sai do layout.
          rotuloOculto && "sr-only",
        )}
      >
        {rotulo}
      </legend>
      <div className="opcoes">{children}</div>
    </fieldset>
  );
}
